// extracted by mini-css-extract-plugin
module.exports = {"container":"SetRate_container__3cuCD","title":"SetRate_title__3Q-3Q","item":"SetRate_item__1zwKW"};